import React, { useCallback, useState, useRef, useMemo, useEffect } from 'react';
import Paper from '../../components/Paper';
import Text from '../../components/Text';
import Radio from '../../components/Radio';
import { createUseStyles } from 'react-jss';
import Button from '../../components/Button';
import clsx from 'clsx';
import { checkforVoucher } from '../../services/ApiService';
import { CartItem } from '../../types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { vatRate,currencyName } from '../../config/serverInfo';

  export interface CheckVoucherProps {
    cart: CartItem[],
    deliveryCost: number,
    discountValue?: number,
    locationId: number,
    code?: string,
    newVoucher: (value: number, code: string) => any;

  }

const CheckVoucher: React.FC<CheckVoucherProps> = ({ cart, deliveryCost, discountValue = 0, code = "", locationId, newVoucher }) => {
  const classes = useStyles();
  const [voucher, setVoucher] = useState(code);
  const [hasVoucher, setHasVoucher] = useState(code != "" ? true : false);
  const [voucherObject, setVoucherObject] = useState({});
  const [discount, setDiscount] = useState(discountValue);
  const subTotal = useMemo(() => {
    return cart.reduce((prev, item) => {
      const itemPrice = item.variant ? item.variant.price : item.product.discountedPrice ? item.product.discountedPrice : item.product.originalPrice;
      console.log("itemPrice")
      console.log(itemPrice)
      return itemPrice * item.quantity + prev;
    }, 0);
  }, [cart]);
  const [total, setTotal] = useState(code != "" ? (subTotal - discountValue + deliveryCost + parseFloat((((subTotal - discountValue + deliveryCost) * 5) / 100).toFixed(2))).toFixed(2) : 0);

  useEffect(() => {
  }, []);
  const voucherRef = useRef(voucher);
  voucherRef.current = voucher;
  const check = useCallback(() => {

    let orders: Record<string, CartItem[]> = {};
    for (let i = 0; i < cart.length; i++) {
      const item = cart[i];
      if (!Array.isArray(orders[item.product.business.id])) {
        orders[item.product.business.id] = [];
      }
      orders[item.product.business.id].push(item);
    }
    let counter = 0
    let body: any = {};
    const form = new FormData();

    for (let key in orders) {
      form.append('orders[]',
        JSON.stringify({
          user_delivery_location_id: locationId,
          currency_id: 1,
          business_id: key,
          products: orders[key].map((item) => ({
            id: item.product.id,
            variant_id: item.variant ? item.variant.id : null,
            quantity: item.quantity
          }))
        })
      )
      counter++;
    }
    form.append('voucher_code', voucher);
    (async () => {
      try {
        var data = await checkforVoucher(form);
        setHasVoucher(true);
        let value = data.discounted_value
        // if (data.type=="FIXED")
        //   value = data.discount_value
        // else
        //   value = (subTotal * data.discount_percentage) / 100
        setDiscount(value);
        newVoucher(value, voucher)
        if (subTotal >= 200)
          deliveryCost = 0

        var vat = (((subTotal - value + deliveryCost) * vatRate) / 100).toFixed(2);
        // USD TASK
        (setTotal((subTotal - value + deliveryCost + parseFloat(vat)).toFixed(2)));
      } catch (e) {
      }
    })()
  }, [voucher]);

  const handleChangevoucher = useCallback((value) => {
    setVoucher(value)

  }, [voucher])
  return (
    <Paper withShadow={false} className="p-3">
      <Text as="h5" className="mb-3" bold>
        Do you have a voucher?
      </Text>


      <div>
        <input
          className={classes.noteInput}
          placeholder="Voucher Number"
          value={voucher}
          onChange={e => handleChangevoucher(e.target.value)}
        />
        <Button
          className={clsx('mr-2', classes.actionBtn)}
          onClick={check}
          color="secondary"
          rounded
        >
          Check
        </Button>
      </div>
      {hasVoucher ?
        <div className={classes.voucherDetails}>

          <div className={classes.textBox}>
            <Text as="span" bold>Subtotal
            </Text>
            <Text as="span" >
              {subTotal} {currencyName}
            </Text>
          </div>

          <div className={classes.textBox}>
            <Text as="span" bold>Discount

            </Text>
            <Text as="span" >
              {discount} {currencyName}
            </Text>
          </div>

          <div className={classes.textBox}>
            <Text as="span" bold>SubTotal - Discount

            </Text>
            <Text as="span" >
              {subTotal - discount}
              {currencyName}
            </Text>
          </div>

          <div className={classes.textBox}>
            <Text as="span" bold>Total

            </Text>
            <Text as="span" >
              {total} {currencyName}
            </Text>
          </div>
        </div>
        : null}
    </Paper >
  );
};

const useStyles = createUseStyles({
  label: {
    display: 'flex',
    alignItems: 'center',
  },
  actionBtn: {
    padding: '5px 20px !important',
  },
  textBox: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  voucherDetails: {
    paddingTop: '10px'
  },
  noteInput: {
    width: 'calc(100% - 120px)',
    fontSize: '20px',
    marginRight: '15px',
    color: '#333',
    border: 'none',
    borderBottom: '2px solid #522583',
    outline: 'none',
    '::placeholder': {
      color: '#ddd',
    },
  },
});

export default CheckVoucher;
